module.exports = __webpack_public_path__ + "img/ar36_samurai02_shop.70730779.png";